// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"e11179af","452":"cc8632ce"}[chunkId] + ".chunk.js";
};